"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IClassNameDescription", {
  enumerable: true,
  get: function get() {
    return _generateClassName.IClassNameDescription;
  }
});
Object.defineProperty(exports, "IClassNameGenerator", {
  enumerable: true,
  get: function get() {
    return _generateClassName.IClassNameGenerator;
  }
});
Object.defineProperty(exports, "IComponentClassNamesGenerator", {
  enumerable: true,
  get: function get() {
    return _generateComponentClassNames.IComponentClassNamesGenerator;
  }
});
Object.defineProperty(exports, "generateClassName", {
  enumerable: true,
  get: function get() {
    return _generateClassName["default"];
  }
});
Object.defineProperty(exports, "generateComponentClassNames", {
  enumerable: true,
  get: function get() {
    return _generateComponentClassNames["default"];
  }
});
var _generateClassName = _interopRequireWildcard(require("./generateClassName"));
var _generateComponentClassNames = _interopRequireWildcard(require("./generateComponentClassNames"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}